import { Editor } from 'slate';

export const withVoid = (types: string[]) => (editor: Editor) => {
  const { isVoid } = editor;

  // eslint-disable-next-line no-param-reassign
  editor.isVoid = (element) => (types.includes(element.type) ? true : isVoid(element));

  return editor;
};
